import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { styled } from "@mui/material/styles";

import PromotionrewardsPhoto from "../../images/GoogleAward.png"

const StyledBox = styled("div")(({ theme }) => ({
  alignSelf: "center",
  width: "100%",
  maxWidth: 600,  // controls the rectangle width
  marginTop: theme.spacing(8),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  outline: "6px solid",
  outlineColor: "hsla(220, 25%, 80%, 0.2)",
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.grey[200],
  boxShadow: "0 0 12px 8px hsla(220, 25%, 80%, 0.2)",
  overflow: "hidden",
  [theme.breakpoints.up("sm")]: {
    marginTop: theme.spacing(10),
  },
  ...theme.applyStyles("dark", {
    boxShadow: "0 0 24px 12px hsla(210, 100%, 25%, 0.2)",
    outlineColor: "hsla(220, 20%, 42%, 0.1)",
    borderColor: (theme.vars || theme).palette.grey[700],
  }),
}));

export default function Staff() {
  return (
    <>
        <Box
          id="hero"
          sx={(theme) => ({
            width: "100%",
            backgroundRepeat: "no-repeat",
            backgroundImage:
              "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
            ...theme.applyStyles("dark", {
              backgroundImage:
                "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)",
            }),
          })}
        >
          <Container
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              pt: { xs: 8, sm: 12 },
              pb: { xs: 8, sm: 6 },
            }}
          >
            <Stack
              spacing={2}
              useFlexGap
              sx={{ alignItems: "center", width: { xs: "100%", sm: "70%" } }}
            >
              <Typography
                variant="h1"
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  fontSize: "clamp(3rem, 10vw, 3.5rem)",
                }}
              >
              Award
                <Typography
                  component="span"
                  variant="h1"
                  sx={(theme) => ({
                    fontSize: "inherit",
                    color: "primary.main",
                    ...theme.applyStyles("dark", {
                      color: "primary.light",
                    }),
                  })}
                >
                
                </Typography>
              </Typography>
            </Stack>
            <StyledBox id="pdf-display">
  <img
    src={PromotionrewardsPhoto}
    alt="Promotions Flyer"
    style={{
      width: "100%",
      height: "auto",
      display: "block",
    }}
  />
</StyledBox>
          </Container>
        </Box>
      {/* <div className="twocolumnContainer">
        <div className="centerContent">
          <img src={NataliePhoto} alt="Jimmy Ngo" className="about_photo" />
        </div>
        <div>
          <Typography className="title" variant="h4">
            Natalie Tung MD, DDS, MBA, EdD
          </Typography>
          <div className="underline" />
          <Typography sx={{ margin: "1rem 0" }}>
            Dr. Natalie Tung is a board certified oral and maxillofacial
            surgeon. She completed her residency in Oral and Maxillofacial
            Surgery, and obtained her MD degree from Harvard Medical School.
            Prior to that, she went to UC Berkeley, majoring biology and
            business, and then graduated with top honors from UCLA School of
            Dentistry. After surgery residency, she served as Assistant
            Professor of Oral and Maxillofacial Surgery and Clinic Director at
            USC for 7 years prior to leaving full-time academia for private
            practice.
          </Typography>
          <Typography sx={{ margin: "1rem 0" }}>
            She enjoys spending time with her 2 boys, traveling, reading,
            volunteering at church, and playing sports, including tennis and
            basketball. She has special interests in dentoalveolar surgery
            including implants and bone grafting, wisdom teeth surgery,
            orthognathic surgery and facial trauma.
          </Typography>
          <Typography>
            She looks forward to providing excellent and compassion care!
          </Typography>
          <ListSection
            title="Education & Background"
            items={[
              "Board-certified oral and maxillofacial surgeon with an MD degree from Harvard Medical School and a DDS from UCLA School of Dentistry.",
              "Completed residency in Oral and Maxillofacial Surgery; previously served as Assistant Professor and Clinic Director at USC for 7 years.",
              "Specializes in dentoalveolar surgery, implants, bone grafting, wisdom teeth surgery, orthognathic surgery, and facial trauma.",
            ]}
            Icon={SchoolIcon}
          />
        </div>
      </div> */}
    </>
  );
}
